module.exports = __webpack_public_path__ + "static/sponsorship_map@2x-d51b9f82a6bc9f1bd2e7c8a6c64c5f7b.png";